"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = anonymous;

function anonymous(locals, escapeFn, include, rethrow) {
  escapeFn = escapeFn || function (markup) {
    return markup == undefined ? '' : String(markup).replace(_MATCH_HTML, encode_char);
  };

  var _ENCODE_HTML_RULES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&#34;",
    "'": "&#39;"
  },
      _MATCH_HTML = /[&<>'"]/g;

  function encode_char(c) {
    return _ENCODE_HTML_RULES[c] || c;
  }

  ;
  ;
  var __output = "";

  function __append(s) {
    if (s !== undefined && s !== null) __output += s;
  }

  ;

  __append("<button\n    class=\"Button Button--layout-");

  __append(escapeFn(this.props.layout));

  __append(escapeFn(this.props.icon ? ' Button--has-icon' : ''));

  __append(escapeFn(this.props.icon ? ' Button--icon-' + this.props.alignIcon : ''));

  __append("\"\n    onclick=\"this.handleClick(event)\"\n    onmousedown=\"this.handleMousedown(event)\"\n    onmouseout=\"this.handleMouseout(event)\"\n    onfocus=\"this.handleFocus(event)\"\n    onblur=\"this.handleBlur(event)\"\n    ontouchstart=\"this.handleTouchstart(event)\"\n    ontouchend=\"this.handleTouchend(event)\"\n    autocomplete=\"off\"\n    ");

  __append(this.props.disabled ? 'disabled="disabled"' : '');

  __append("\n>\n    <div class=\"Button__wrapper\">\n        ");

  if (this.props.icon && this.props.alignIcon === 'left') {
    ;

    __append("\n            <i class=\"Button__icon IKEA--icon-");

    __append(escapeFn(this.props.icon));

    __append("\"></i>\n        ");
  }

  ;

  __append("\n\n        ");

  if (this.props.label) {
    ;

    __append("\n            <span class=\"Button__label\">");

    __append(escapeFn(this.props.label));

    __append("</span>\n        ");
  }

  ;

  __append("\n\n        ");

  if (this.props.icon && this.props.alignIcon === 'right') {
    ;

    __append("\n            <i class=\"Button__icon IKEA--icon-");

    __append(escapeFn(this.props.icon));

    __append("\"></i>\n        ");
  }

  ;

  __append("\n    </div>\n</button>\n");

  return __output;
}